export const Sources = [
    {
        id: 1,
        name: "SalesForce",
        obj_name: "SalesForce Bussiness Object"
    },
    {
        id: 2,
        name: "NetSuite",
        obj_name: "NetSuite Bussiness Object"
    },
    {
        id: 3,
        name: "TestSource",
        obj_name: "TestSource Bussiness Object"
    }
]

